import store from '../store';

const getReduxStore = () => {
    return store.getState();
};

store.subscribe(getReduxStore);

export default getReduxStore;